import * as dayjs from 'dayjs';
import Button from '../../components/Button';

import { useSocket } from '../../context/SocketContext';
import { useRoom } from '../../context/RoomContext';
import { usePlayer } from '../../context/PlayerContext';

const convertTime = (milliseconds: number) => {
  const seconds = Math.floor(milliseconds / 1000);

  return `${seconds}.${milliseconds % 1000}s`;
};

export default function Ranking() {
  const socket = useSocket();
  const { players } = useRoom();
  const player = usePlayer();

  return (
    <div>
      <div className="mb-10 flex flex-col items-start gap-1">
        <h2 className="mb-1">Ranking</h2>

        {players
          .sort((a: Player, b: Player) =>
            (a.timeSpent || Number.POSITIVE_INFINITY) >=
            (b.timeSpent || Number.POSITIVE_INFINITY)
              ? 1
              : -1,
          )
          .map((player: Player, index: number) => (
            <div key={player.id} className="flex gap-2">
              <p className="font-bold">{index + 1}.</p>

              <p
                className={`font-bold ${
                  player.ready ? 'text-green-500' : 'text-red-600'
                }`}
              >
                {player.id}
                {player.id === socket.id && ' (você)'}
              </p>

              <p>
                {player.timeSpent
                  ? `${convertTime(player.timeSpent)}`
                  : player.playing
                  ? 'Jogando...'
                  : ''}
              </p>
            </div>
          ))}
      </div>

      <div className="flex flex-col justify-center items-center gap-2">
        {players.every((player: Player) => !player.playing) ? (
          <>
            <p>Waiting all players being ready.</p>

            <Button
              className={player.ready ? `bg-green-500` : `bg-red-600`}
              onClick={() => player.toggleReady()}
            >
              {player.ready ? 'READY' : 'NOT READY'}
            </Button>
          </>
        ) : (
          <p>Waiting all the players finish the match.</p>
        )}
      </div>
    </div>
  );
}
